/* =========================================================
   ANOKHA — parallax + scroll motion engine (no dependencies)
   -----------------------------------------------------------
   data-parallax="0.2"    vertical scroll speed (+ down, - up)
   data-parallax-x="0.1"  optional horizontal drift
   data-float             adds a gentle idle bob
   data-tilt              container that reacts to mouse
   data-tilt-layer="0.6"  depth of a child inside [data-tilt]
   .reveal                fades/slides in when scrolled into view
   ========================================================= */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------- Header ---------------- */
  var header = document.getElementById("header");
  var burger = document.getElementById("burger");
  var nav = document.getElementById("nav");

  if (burger && nav) {
    burger.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      burger.setAttribute("aria-expanded", String(open));
    });
    nav.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        nav.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* a photo that has not been dropped in yet hides itself, leaving the
     gradient on .story-media rather than a broken-image icon */
  [].slice.call(document.querySelectorAll(".story-photo")).forEach(function (img) {
    img.addEventListener("error", function () { img.style.display = "none"; });
  });

  var yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ---------------- Parallax items ---------------- */
  var items = [].slice.call(document.querySelectorAll("[data-parallax]")).map(function (el) {
    return {
      el: el,
      speed: parseFloat(el.dataset.parallax) || 0,
      speedX: parseFloat(el.dataset.parallaxX) || 0,
      float: el.hasAttribute("data-float"),
      phase: Math.random() * Math.PI * 2,
      layer: parseFloat(el.dataset.tiltLayer) || 0,
      // elements that are BOTH .reveal and parallax need their entrance
      // offset folded into the same transform, or one would cancel the other
      revealer: el.classList.contains("reveal"),
      revOff: el.classList.contains("reveal") && !reduced ? 34 : 0,
      center: 0,
      height: 0
    };
  });

  var tiltRoots = [].slice.call(document.querySelectorAll("[data-tilt]")).map(function (el) {
    return { el: el, layers: [].slice.call(el.querySelectorAll("[data-tilt-layer]")) };
  });

  function measure() {
    var sy = window.pageYOffset;
    items.forEach(function (it) {
      var prev = it.el.style.transform;
      it.el.style.transform = "none";
      var r = it.el.getBoundingClientRect();
      it.center = r.top + sy + r.height / 2;
      it.height = r.height;
      it.el.style.transform = prev;
    });
  }

  /* ---------------- Mouse tilt ---------------- */
  var mouse = { x: 0, y: 0, tx: 0, ty: 0 };
  if (!reduced && window.matchMedia("(pointer:fine)").matches) {
    window.addEventListener("mousemove", function (e) {
      mouse.tx = (e.clientX / window.innerWidth - 0.5) * 2;   // -1 .. 1
      mouse.ty = (e.clientY / window.innerHeight - 0.5) * 2;
    }, { passive: true });
  }

  /* ---------------- Render loop ---------------- */
  var smoothY = window.pageYOffset;

  function render(now) {
    var sy = window.pageYOffset;
    var vh = window.innerHeight;

    // eased scroll value -> silky motion instead of 1:1 jumps
    smoothY += (sy - smoothY) * 0.12;
    mouse.x += (mouse.tx - mouse.x) * 0.06;
    mouse.y += (mouse.ty - mouse.y) * 0.06;

    var viewCenter = smoothY + vh / 2;
    var t = now / 1000;

    for (var i = 0; i < items.length; i++) {
      var it = items[i];

      // skip work for anything far outside the viewport
      if (it.center + it.height / 2 < sy - vh * 0.6 || it.center - it.height / 2 > sy + vh * 1.6) continue;

      var delta = viewCenter - it.center;
      var y = delta * it.speed;
      var x = delta * it.speedX;

      if (it.float && !reduced) y += Math.sin(t * 0.9 + it.phase) * 9;

      if (it.layer) {
        x += mouse.x * it.layer * 16;
        y += mouse.y * it.layer * 12;
      }

      if (it.revOff) {
        if (it.el.classList.contains("in-view")) it.revOff += (0 - it.revOff) * 0.08;
        if (it.revOff < 0.4) it.revOff = 0;
        y += it.revOff;
      }

      it.el.style.transform = "translate3d(" + x.toFixed(2) + "px," + y.toFixed(2) + "px,0)";
    }

    for (var j = 0; j < tiltRoots.length; j++) {
      var root = tiltRoots[j];
      for (var k = 0; k < root.layers.length; k++) {
        var layerEl = root.layers[k];
        if (layerEl.hasAttribute("data-parallax")) continue; // already handled above
        var depth = parseFloat(layerEl.dataset.tiltLayer) || 0;
        layerEl.style.transform =
          "translate3d(" + (mouse.x * depth * 16).toFixed(2) + "px," + (mouse.y * depth * 12).toFixed(2) + "px,0)";
      }
    }

    if (header) header.classList.toggle("scrolled", sy > 24);

    requestAnimationFrame(render);
  }

  /* ---------------- Reveal on scroll ----------------
     Only worth running when the hidden state is actually applied. `.anim` is
     the single source of truth for that, set in the document head; without it
     the content is already visible and there is nothing to reveal. */
  var revealEls = [].slice.call(document.querySelectorAll(".reveal"));
  if (document.documentElement.classList.contains("anim") &&
      "IntersectionObserver" in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, idx) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.style.transitionDelay = (idx * 90) + "ms";
        el.classList.add("in-view");
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in-view"); });
  }

  /* ---------------- Number count-up ---------------- */
  var nums = [].slice.call(document.querySelectorAll(".num[data-count]"));
  if ("IntersectionObserver" in window && !reduced) {
    var numIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countUp(entry.target);
        numIO.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (el) { numIO.observe(el); });
  }

  function countUp(el) {
    var target = parseFloat(el.dataset.count) || 0;
    var suffix = el.dataset.suffix || "";
    var decimals = parseInt(el.dataset.decimals, 10) || 0;
    var start = null;
    var dur = 1300;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var value = target * eased;
      el.textContent = (decimals ? value.toFixed(decimals) : Math.round(value)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------------- Nav scroll-spy ---------------- */
  var navLinks = [].slice.call(document.querySelectorAll(".nav a[href^='#']"));
  var sections = navLinks
    .map(function (a) { return document.querySelector(a.getAttribute("href")); })
    .filter(Boolean);

  if (sections.length && "IntersectionObserver" in window) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        navLinks.forEach(function (a) {
          var on = a.getAttribute("href") === "#" + entry.target.id;
          a.classList.toggle("active", on);
          if (on) { a.setAttribute("aria-current", "true"); } else { a.removeAttribute("aria-current"); }
        });
      });
    }, { rootMargin: "-45% 0px -50% 0px" });
    sections.forEach(function (s) { spy.observe(s); });
  }

  /* ---------------- Hero illustration parallax ----------------
     The scene's internal motion is pure CSS (see .a-orb/.a-gl/.a-gr/.a-fig).
     This adds depth between the art and the copy: they drift in opposite
     directions with the pointer. It writes transform on the <svg> and the copy
     block only — never on the animated groups, because a running CSS animation
     outranks an inline style and the two would fight. */
  var heroSvg = document.querySelector(".hero-svg");
  var heroCopy = document.querySelector(".hero-copy");

  if (heroSvg && !reduced && window.matchMedia("(pointer: fine)").matches) {
    var hx = 0, hy = 0, htx = 0, hty = 0, heroRaf = null, heroOn = false;

    window.addEventListener("mousemove", function (e) {
      htx = (e.clientX / window.innerWidth - 0.5) * 2;
      hty = (e.clientY / window.innerHeight - 0.5) * 2;
    }, { passive: true });

    var heroLoop = function () {
      if (!heroOn) return;
      hx += (htx - hx) * 0.06;
      hy += (hty - hy) * 0.06;
      heroSvg.style.transform =
        "translate3d(" + (hx * 14).toFixed(2) + "px," + (hy * 10).toFixed(2) + "px,0) scale(1.03)";
      if (heroCopy) {
        heroCopy.style.transform =
          "translate3d(" + (hx * -6).toFixed(2) + "px," + (hy * -4).toFixed(2) + "px,0)";
      }
      heroRaf = requestAnimationFrame(heroLoop);
    };

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !heroOn) { heroOn = true; heroRaf = requestAnimationFrame(heroLoop); }
          else if (!entry.isIntersecting && heroOn) { heroOn = false; if (heroRaf) cancelAnimationFrame(heroRaf); }
        });
      }, { threshold: 0 }).observe(heroSvg);
    } else {
      heroOn = true; heroRaf = requestAnimationFrame(heroLoop);
    }
  }

  /* ---------------- Newsletter form ---------------- */
  var signup = document.getElementById("signup");
  if (signup) {
    var email = document.getElementById("signup-email");
    var status = document.getElementById("signup-status");

    signup.addEventListener("submit", function (e) {
      e.preventDefault();
      var value = email.value.trim();

      if (!value) {
        setStatus("Enter your email address to get the code.", false);
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
        setStatus("That email address is missing something. Check it and try again.", false);
        return;
      }
      // Wire this to your real list (Shopify customer API / Klaviyo / Mailchimp).
      setStatus("Code sent. Check " + value + " for 10% off.", true);
      email.value = "";
    });

    email.addEventListener("input", function () {
      email.removeAttribute("aria-invalid");
      status.textContent = "";
      status.className = "form-status";
    });

    function setStatus(message, ok) {
      status.textContent = message;
      status.className = "form-status " + (ok ? "is-ok" : "is-error");
      if (ok) { email.removeAttribute("aria-invalid"); }
      else { email.setAttribute("aria-invalid", "true"); email.focus(); }
    }
  }

  /* ---------------- Boot ---------------- */
  measure();
  window.addEventListener("load", measure);
  window.addEventListener("resize", debounce(measure, 150));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  requestAnimationFrame(render);

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }
})();

/* =========================================================
   ANOKHA — shop page (colourway swap + family nav)
   ---------------------------------------------------------
   No-ops on any page without #shop-data, so the home page and the product
   pages load this file unchanged. Three jobs:

     1. Colourway in place. Pressing a swatch on a card re-prints that card's
        photograph in the chosen filament — clipped to nothing, uncovered
        bottom-up behind an orange print head, the same reveal the product
        page uses. The card's link picks up ?c=N so the colour you chose is
        still chosen when the product page opens.
     2. Print-in on scroll. Cards get .printed once, the first time they come
        into view. The card itself never moves: in a uniform grid, neighbours
        sliding at different times reads as a layout bug.
     3. Family nav. Highlights the section you are in. They are jump links,
        not filters — with 13 products, hiding ten of them to look at three
        is not help.
   ========================================================= */
(function () {
  "use strict";

  var cards = [].slice.call(document.querySelectorAll(".shop-card"));
  var adders = [].slice.call(document.querySelectorAll(".shop-add"));
  if (!cards.length && !adders.length) return;

  /* Two shapes of the same data. On Shopify each card carries its own
     colourways in a script tag beside it, because the grid is assembled from
     independent sections and there is no one place to put a page-level blob.
     The static prototype emits that blob, so both are read. */
  var pageData = document.getElementById("shop-data");
  var DATA = pageData ? JSON.parse(pageData.textContent) : {};

  function variantsFor(card) {
    var own = card.querySelector(".card-variants");
    if (own) {
      try { return JSON.parse(own.textContent); } catch (e) { return null; }
    }
    return DATA[card.getAttribute("data-slug")] || null;
  }

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (document.documentElement.getAttribute("data-motion") === "off") reduced = true;

  /* The head script already decided this and stamped the result on <html>.
     Reading it rather than re-deciding keeps one source of truth: if the
     class is not there, nothing is hidden and nothing should animate. */
  var animating = document.documentElement.classList.contains("anim") &&
                  !reduced && "IntersectionObserver" in window;

  /* ---------------- Colourway swap ----------------
     Grid-only. The home page's best sellers have bag buttons but no swatches,
     so this loop simply does not run there while the add-to-bag handler at
     the bottom still does. */
  cards.forEach(function (card) {
    var variants = variantsFor(card);
    if (!variants) return;

    var img = card.querySelector(".shop-shot img");
    var head = card.querySelector(".shot-head");
    var label = card.querySelector(".sw-name");
    var link = card.querySelector(".shop-name a");
    var swatches = [].slice.call(card.querySelectorAll(".sw"));
    var base = link.getAttribute("href");

    swatches.forEach(function (b) {
      b.addEventListener("click", function () {
        var i = +b.getAttribute("data-i");
        var v = variants[i];
        if (!v) return;

        swatches.forEach(function (o) {
          o.setAttribute("aria-pressed", String(+o.getAttribute("data-i") === i));
        });
        img.src = v.img;
        img.alt = v.alt;

        /* the bag button adds the colour you are looking at, not the one the
           page loaded with */
        var bag = card.querySelector(".shop-add");
        if (bag && v.id) {
          bag.setAttribute("data-variant-id", v.id);
          bag.disabled = v.available === false;
        }
        label.innerHTML = "";
        label.appendChild(document.createElement("b")).textContent = v.name;
        /* carry the choice through to the product page */
        link.setAttribute("href", i === 0 ? base : base + "?c=" + i);

        if (reduced) return;
        /* the scroll reveal owns clip-path on this image while it is still
           animating in; make sure that has finished before re-printing */
        card.classList.add("printed");
        img.classList.remove("printing");
        head.classList.remove("running");
        void img.offsetWidth;               /* restart both animations */
        img.classList.add("printing");
        head.classList.add("running");
      });
    });
  });

  /* ---------------- Print-in on scroll ----------------
     The clip that hides an unprinted photo lives behind `.anim` on <html>,
     which a three-line script in the document head sets before anything
     paints. If that script did not run — no JS, no IntersectionObserver,
     reduced motion — the class is absent and the photographs are simply
     there. A blank card is not an acceptable fallback for a missed animation
     on a shop page, and there is a 2s backstop underneath that too. */
  if (animating) {
    var printer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("printed");
        printer.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.15 });
    cards.forEach(function (card) { printer.observe(card); });

    setTimeout(function () {
      cards.forEach(function (card) { card.classList.add("printed"); });
    }, 2000);
  }

  /* ---------------- Family nav ---------------- */
  var links = [].slice.call(document.querySelectorAll(".famnav .chip"));
  var sections = links
    .map(function (a) { return document.querySelector(a.getAttribute("href")); })
    .filter(Boolean);

  if (sections.length && "IntersectionObserver" in window) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (a) {
          var on = a.getAttribute("href") === "#" + entry.target.id;
          a.classList.toggle("active", on);
          if (on) { a.setAttribute("aria-current", "true"); }
          else { a.removeAttribute("aria-current"); }
        });
      });
    }, { rootMargin: "-25% 0px -60% 0px" });
    sections.forEach(function (s) { spy.observe(s); });
  }

  /* ---------------- Add to bag ---------------- */
  var toast = document.getElementById("bag-toast");
  var toastTimer = null;

  document.addEventListener("click", function (e) {
    var b = e.target.closest(".shop-add");
    if (!b || !toast) return;
    var card = b.closest(".shop-card") || b.closest(".work-card");
    if (!card) return;
    var nameEl = card.querySelector(".shop-name a") || card.querySelector(".work-title a");
    var name = nameEl ? nameEl.textContent.trim() : "";
    var colour = card.querySelector(".sw-name b");
    var id = b.getAttribute("data-variant-id");

    if (window.Shopify && window.fetch && id) {
      b.setAttribute("aria-busy", "true");
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          return fetch(window.Shopify.routes.root + "cart.js", { headers: { "Accept": "application/json" } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var badge = document.getElementById("cart-count");
          if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
          announce("Added " + name + (colour ? " in " + colour.textContent : "") + " to your bag.");
        })
        .catch(function () { announce("That could not be added. Try again in a moment."); })
        .then(function () { b.removeAttribute("aria-busy"); });
      return;
    }

    announce("Added " + name + (colour ? " in " + colour.textContent : "") + " to your bag.");
  });

  function announce(message) {
    toast.textContent = "";
    var ico = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    ico.setAttribute("class", "ico");
    ico.appendChild(document.createElementNS("http://www.w3.org/2000/svg", "use"))
       .setAttribute("href", "#i-bag");
    toast.appendChild(ico);
    toast.appendChild(document.createTextNode(message));
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 3600);
  }
})();
